module.exports = __webpack_public_path__ + "static/media/79.f8d63c71.png";